import { useState } from "react";
import { PageLayout } from "@/components/PageLayout";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { CalculatorSuperCalcCTA } from "@/components/CalculatorSuperCalcCTA";
import { calculatorCTAs } from "@/data/calculatorCTAs";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Percent } from "lucide-react";
import { getCalculatorSEO } from "@/hooks/useSEO";

export default function DiscountCalculator() {
  const [originalPrice, setOriginalPrice] = useState("");
  const [discountPercent, setDiscountPercent] = useState("");
  const [results, setResults] = useState<any>(null);

  const calculateDiscount = () => {
    const price = parseFloat(originalPrice);
    const discount = parseFloat(discountPercent);
    
    if (!price || !discount || price <= 0 || discount <= 0) return;
    
    const discountAmount = price * (discount / 100);
    const finalPrice = price - discountAmount;
    const savings = discountAmount;
    
    setResults({
      discountAmount: discountAmount.toFixed(2),
      finalPrice: finalPrice.toFixed(2),
      savings: savings.toFixed(2)
    });
  };

  return (
    <PageLayout calculatorName="Discount Calculator" calculatorPath="/calculator/discount">
      <div className="grid gap-8 md:grid-cols-2">
        <Card>
          <CardHeader>
            <CardTitle>Calculate Discount</CardTitle>
            <CardDescription>Enter price and discount</CardDescription>
          </CardHeader>
          <CardContent className="space-y-4">
            <div>
              <Label>Original Price ($)</Label>
              <Input
                type="number"
                value={originalPrice}
                onChange={(e) => setOriginalPrice(e.target.value)}
                placeholder="100.00"
                step="0.01"
              />
            </div>
            <div>
              <Label>Discount Percentage (%)</Label>
              <Input
                type="number"
                value={discountPercent}
                onChange={(e) => setDiscountPercent(e.target.value)}
                placeholder="20"
              />
            </div>
            <Button onClick={calculateDiscount} className="w-full">
              Calculate
            </Button>
          </CardContent>
        </Card>

        {results && (
          <>
            <Card>
              <CardHeader>
                <CardTitle>Sale Price</CardTitle>
              </CardHeader>
              <CardContent className="space-y-4">
                <div className="text-center mb-4">
                  <div className="text-5xl font-bold text-primary mb-2">
                    ${results.finalPrice}
                  </div>
                  <div className="text-lg text-muted-foreground">Final Price</div>
                </div>
                <div className="flex justify-between text-lg">
                  <span>Original Price:</span>
                  <span className="line-through text-muted-foreground">${originalPrice}</span>
                </div>
                <div className="flex justify-between text-lg">
                  <span>Discount ({discountPercent}%):</span>
                  <span className="text-red-500">-${results.discountAmount}</span>
                </div>
                <div className="flex justify-between text-lg border-t pt-4">
                  <span>You Save:</span>
                  <span className="font-semibold text-green-500">${results.savings}</span>
                </div>
              </CardContent>
            </Card>

            <div className="md:col-span-2">
              <CalculatorSuperCalcCTA config={calculatorCTAs["discount"]} />
            </div>
          </>
        )}
      </div>
    </PageLayout>
  );
}
